import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-freshdesk',
  templateUrl: './freshdesk.component.html',
  styleUrls: ['./freshdesk.component.css']
})
export class FreshdeskComponent implements OnInit {

  constructor( ) { }

  ngOnInit() {
    if (!window.location.hash.startsWith("#state=")){//not part of a login
      window.location.href="https://geoinsights.freshdesk.com";
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/freshdesk/freshdesk.component.ts